'use client';

import React from 'react';
import { cn } from '../../../utils/cn/cn';

/**
 * The dialog footer container
 * */
const DialogFooter = ({ children, className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('bg-color-background-base mt-auto p-2 shadow-sm', className)} {...props}>
    <div className="flex gap-1 sm:flex-col sm:items-stretch md:flex-row-reverse md:items-center">
      {children}
    </div>
  </div>
);

DialogFooter.displayName = 'DialogFooter';

export { DialogFooter };
